<template>
  <section >
    <vue-headful
        :title="$t('pages.skills') + ' - Fernando Mata'"
      />
    <div :class="classForSize">
      <div class="skillSetContainer" v-for="skillSet in skillSets" :key="skillSet.title">
        <SkillCard :skillSet="skillSet" />
      </div>
    </div>
  </section>
</template>

<script>
import SkillCard from '../components/SkillCard.vue'
import SkillSets from '../data/SkillSets.json'

export default {
  components: {
    SkillCard
  },
  computed: {
    skillSets() {
      return SkillSets.sort(function(a, b) {
        return a.position > b.position
      })
    },
    classForSize() {
      switch (this.$mq) {
        case "tiny":
          return "column"
        case "small":
          return "divided"
        default:
          return  "full"
      }
    }
  }
}
</script>

<style scoped>
   div .full {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .skillSetContainer {
    display: inline-block;
  }
  .skillCard {
    display: inline-block;
    margin-bottom: 2em;
  }
  div .divided {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .divided .skillSetContainer {
    min-width: 50%;
    text-align: center;
  }
  div .column {
    display: inline-block;
    text-align: center;
  }
  .column .skillSetContainer {
    min-width: 60%;
    text-align: center;
  }
</style>

